import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBankaList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBankaList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VBank: any[];
  Boss_VBank_dummy: any[];
  Boss_VBankHeader: any[];
  Boss_VBankHeader_dummy: any[];
  Boss_VBankTotal: any[];
  Boss_VBankTotal_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp115365Visible: "visible" | "hidden";
  isComp330937Visible: "visible" | "hidden";
}

export class BankaList_ScreenBase extends React.PureComponent<
  IBankaList_ScreenProps,
  any
> {
  bankalist_38156_value_kuikaSelectBoxRef: React.RefObject<any>;
  bankalist_222385_value_kuikaTableRef: React.RefObject<any>;
  bankalist_596129_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "d61e63a9-8293-4745-a470-4a2b07a42731",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 531074, PropertyName: "label", Value: "Profil" },
        { Id: 787275, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 761136, PropertyName: "value", Value: "Banka Hesapları" },
        { Id: 588216, PropertyName: "value", Value: "Varlıklarım / Borçlarım" },
        { Id: 450762, PropertyName: "value", Value: "Alacaklarım" },
        { Id: 179082, PropertyName: "value", Value: "Borçlarım" },
        { Id: 834055, PropertyName: "value", Value: "Net Varlık" },
        { Id: 38156, PropertyName: "placeholder", Value: "Borç/Alacak bakiye" },
        { Id: 542451, PropertyName: "placeholder", Value: "Ad..." },
        { Id: 31976, PropertyName: "label", Value: "Ara" },
        { Id: 950435, PropertyName: "label", Value: "Temizle" },
        {
          Id: 222385,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 627176, PropertyName: "title", Value: "Title" },
        { Id: 593319, PropertyName: "value", Value: "Ad" },
        {
          Id: 480138,
          PropertyName: "value",
          Value: "[datafield:accountdescription]",
        },
        { Id: 577040, PropertyName: "value", Value: "Bakiye" },
        { Id: 294943, PropertyName: "value", Value: "[datafield:balance]" },
        { Id: 947506, PropertyName: "value", Value: "Para Birimi" },
        {
          Id: 713175,
          PropertyName: "value",
          Value: "[datafield:doccurrencycode]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.bankalist_38156_value_kuikaSelectBoxRef = React.createRef();
    this.bankalist_542451_value_kuikaTextInputRef = React.createRef();
    this.bankalist_222385_value_kuikaTableRef = React.createRef();
    this.bankalist_596129_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VBank: [],
      Boss_VBankHeader: [],
      Boss_VBankTotal: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_38156: [
        { key: "0", text: "Tümü" },
        { key: "1", text: "Borç Bakiyeliler" },
        { key: "2", text: "Alacak Bakiyeliler" },
      ],
      isComp115365Visible: "hidden",
      isComp330937Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bankalist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BankaListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("bankalist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bankalist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BankaListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      bankalist_958439_value: this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BankaListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("0", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BankaList/BankaListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VBank = result?.data.boss_VBank;

    stateVars.Boss_VBankHeader = result?.data.boss_VBankHeader;

    stateVars.Boss_VBankTotal = result?.data.boss_VBankTotal;
    formVars.bankalist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VBankTotal !== undefined
        ? stateVars.Boss_VBankTotal?.length > 0
          ? stateVars.Boss_VBankTotal[0].creditBalance
          : null
        : this.state.Boss_VBankTotal?.length > 0
        ? this.state.Boss_VBankTotal[0].creditBalance
        : null
    );
    formVars.bankalist_81616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VBankTotal !== undefined
        ? stateVars.Boss_VBankTotal?.length > 0
          ? stateVars.Boss_VBankTotal[0].debitBalance
          : null
        : this.state.Boss_VBankTotal?.length > 0
        ? this.state.Boss_VBankTotal[0].debitBalance
        : null
    );
    formVars.bankalist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VBankTotal !== undefined
        ? stateVars.Boss_VBankTotal?.length > 0
          ? stateVars.Boss_VBankTotal[0].balance
          : null
        : this.state.Boss_VBankTotal?.length > 0
        ? this.state.Boss_VBankTotal[0].balance
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.bankalist_958439_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BankaListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BankaListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bankalist_958439_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    stateVars.dataSource_550516 =
      stateVars.Boss_VBankHeader ?? this.state.Boss_VBankHeader;
    formVars.bankalist_487160_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VBankTotal !== undefined
        ? stateVars.Boss_VBankTotal?.length > 0
          ? stateVars.Boss_VBankTotal[0].creditBalance
          : null
        : this.state.Boss_VBankTotal?.length > 0
        ? this.state.Boss_VBankTotal[0].creditBalance
        : null
    );

    formVars.bankalist_81616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VBankTotal !== undefined
        ? stateVars.Boss_VBankTotal?.length > 0
          ? stateVars.Boss_VBankTotal[0].debitBalance
          : null
        : this.state.Boss_VBankTotal?.length > 0
        ? this.state.Boss_VBankTotal[0].debitBalance
        : null
    );

    formVars.bankalist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VBankTotal !== undefined
        ? stateVars.Boss_VBankTotal?.length > 0
          ? stateVars.Boss_VBankTotal[0].balance
          : null
        : this.state.Boss_VBankTotal?.length > 0
        ? this.state.Boss_VBankTotal[0].balance
        : null
    );

    stateVars.dataSource_222385 = stateVars.Boss_VBank ?? this.state.Boss_VBank;
    formVars.bankalist_596129_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].totalCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].totalCount
        : null
    );
    formVars.bankalist_596129_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].pageCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].pageCount
        : null
    );

    formVars.bankalist_596129_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].totalCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].totalCount
        : null
    );
    formVars.bankalist_596129_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].pageCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BankaListComponent_961468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BankaList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "344479",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_531074_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BankaList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_787275_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_38156_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_38156_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BankaList/BankaListComponent_38156_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VBank = result?.data.boss_VBank;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BankaListComponent_38156_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BankaListComponent_38156_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bankalist_596129_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_222385 = stateVars.Boss_VBank ?? this.state.Boss_VBank;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_31976_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_38156_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_596129_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BankaList/BankaListComponent_31976_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VBank = result?.data.boss_VBank;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BankaListComponent_31976_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BankaListComponent_31976_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 = stateVars.Boss_VBank ?? this.state.Boss_VBank;
    formVars.bankalist_596129_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].totalCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].totalCount
        : null
    );
    formVars.bankalist_596129_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].pageCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].pageCount
        : null
    );

    formVars.bankalist_596129_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].totalCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].totalCount
        : null
    );
    formVars.bankalist_596129_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].pageCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_950435_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bankalist_542451_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bankalist_38156_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bankalist_596129_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BankaListComponent_950435_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BankaListComponent_950435_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("0", "string"),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_596129_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BankaList/BankaListComponent_950435_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VBank = result?.data.boss_VBank;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BankaListComponent_950435_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BankaListComponent_950435_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 = stateVars.Boss_VBank ?? this.state.Boss_VBank;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_91072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BankaDetay",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "bankalist_222385_value",
          "accountCode"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BankaList",
      "BankaDetay",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BankaListComponent_596129_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BankDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_38156_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bankalist_596129_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BankaList/BankaListComponent_596129_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VBank = result?.data.boss_VBank;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BankaListComponent_596129_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BankaListComponent_596129_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 = stateVars.Boss_VBank ?? this.state.Boss_VBank;
    formVars.bankalist_596129_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].totalCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].totalCount
        : null
    );
    formVars.bankalist_596129_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].pageCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].pageCount
        : null
    );

    formVars.bankalist_596129_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].totalCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].totalCount
        : null
    );
    formVars.bankalist_596129_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VBank !== undefined
        ? stateVars.Boss_VBank?.length > 0
          ? stateVars.Boss_VBank[0].pageCount
          : null
        : this.state.Boss_VBank?.length > 0
        ? this.state.Boss_VBank[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [344479, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BankaListPageInit();
    }
  }
}
